<template>
  <div class="row mt-5">
    <div class="col-1"></div>
    <div class="col-10">
      <base-button v-b-toggle.collapse-update block class="btn-primary"> Actualizacón de Indices</base-button>
      <b-collapse id="collapse-update">
        <b-card title="Actualización" sub-title="Presionar boton del indice que desea actualziar">
          <div class="row text-center">
            <div class="col-sm-12 col-md-4 col-lg-4">
              <base-button @click="update_index('productsku')" type="warning">Actualizar Catalogo</base-button>
            </div>
            <div class="col-sm-12 col-md-4 col-lg-4">
              <base-button @click="update_index('product')" type="warning">Actualizar Productos</base-button>
            </div>
            <div class="col-sm-12 col-md-4 col-lg-4">
              <base-button @click="update_index('restaurant')" type="warning">Actualizar Restaurantes</base-button>
            </div>
          </div>
          <div class="row text-center mt-2">
            <div class="col-sm-12 col-md-6 col-lg-6">
              <base-button @click="update_index('users')" type="warning">Actualizar Usuarios</base-button>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
              <base-button @click="update_index('order')" type="warning">Actualizar ordenes</base-button>
            </div>
          </div>
        </b-card>
      </b-collapse>
    </div>
    <div class="col-1"></div>
  </div>
</template>

<script>
import {bus} from "@/components/Configuration/bus_configuration";
import {configuration_service} from "@/services/configuration/ConfigurationService";
import swal from "sweetalert";

export default {
  name: "UpdateIndex",
  data() {
    return {
      index: ''
    }
  },
  methods: {
    update_index(index) {
      this.index = index
      configuration_service.update_indice(index)
    }
  },
  created() {
    bus.$on('create_indice', (response) => {
      if (response) {
        this.index = ''
        swal({
          icon: "success",
          text: "Se Ha Actualizado el indice correctamente",
          button: "Aceptar"
        })
        //configuration_service.update_indice(this.index)
      }
    })
    bus.$on('update_indice', (response) => {
      if (response) {
        this.index = ''
        swal({
          icon: "success",
          text: "Se Ha Actualizado el indice correctamente",
          button: "Aceptar"
        })
      }
    })
  }
}
</script>

<style scoped>

</style>
